import {
    RESET_GROUP_PAGE,
    GROUP_PAGE_SEARCH_USER,
    GROUP_PAGE_SEARCH_USER_DONE,
    GROUP_PAGE_UNBLOCK_USER_DONE,
    GROUP_PAGE_UNBLOCK_USER,
    UPDATE_GROUP_SEARCH_USER_CONNECTION_STATUS,
    GROUP_PAGE_CANCEL_INVITE_USER,
    GROUP_PAGE_CANCEL_INVITE_USER_DONE,
    GROUP_PAGE_INVITE_USER,
    GROUP_PAGE_INVITE_USER_DONE,
    GROUP_PAGE_SET_INVITE_ERROR_DIALOG_STATE
} from '../../actions/ActionTypes';

import { MIN_START_SEARCH_LENGTH } from 'utils/groups/GroupsUtil';

const INITIAL_STATE = {
    searching: false,
    error: false,
    keyword: '',
    list: [],
    hasMore: false,
    nextCursor: 0,
    processing: [],
    showSearchHint: false,
    showNoResult: false,
    inviteErrorDialog: {
        open: false,
        errorType: '',
        inviteDTO: null
    }
};

/** selector */

export const selectGroupPageInvite = (state) => state.groupPageInvite;

export const selectGroupPageInviteKeyword = (state) => {
    const groupPageInvite = selectGroupPageInvite(state);
    return groupPageInvite.keyword;
};

export const selectGroupPageInviteNextCursor = (state) => {
    const groupPageInvite = selectGroupPageInvite(state);
    return groupPageInvite.nextCursor;
};

export const selectGroupPageInviteProcessing = (state, { displayName }) => {
    const groupPageInvite = selectGroupPageInvite(state);
    return groupPageInvite.processing.includes(displayName);
};

export const selectGroupInviteErrorDialogState = (state) => {
    const groupPageInvite = selectGroupPageInvite(state);
    return groupPageInvite.inviteErrorDialog;
};

/** action handlers */
export const searchUser = (state, action) => {
    const { keyword, reset } = action;

    const newKeyword = typeof keyword === 'string' ? keyword : state.keyword;

    return {
        ...state,
        searching: newKeyword.length >= MIN_START_SEARCH_LENGTH,
        error: false,
        hasMore: reset ? false : state.hasMore,
        keyword: newKeyword,
        list: reset ? INITIAL_STATE.list : state.list,
        showSearchHint: newKeyword.length < MIN_START_SEARCH_LENGTH,
        showNoResult: false
    };
};

export const searchUserDone = (state, action) => {
    const { error, list, hasMore, nextCursor } = action;
    if (error) {
        return {
            ...state,
            searching: false,
            error: true
        };
    }

    const newList = state.list.concat(list);
    return {
        ...state,
        searching: false,
        error: false,
        list: newList,
        hasMore,
        nextCursor,
        showNoResult: newList.length === 0
    };
};

export const updateSearchUserConnectionStatus = (state, action) => {
    const foundIndex = state.list.findIndex((item) => item.userId === action.connectionStatus.userProfileId);
    if (foundIndex < 0) {
        return state;
    }
    const slice1 = state.list.slice(0, foundIndex);
    const slice2 = state.list.slice(foundIndex + 1);
    const updateItem = {
        ...state.list[foundIndex],
        ...action.connectionStatus
    };

    return {
        ...state,
        list: [...slice1, updateItem, ...slice2]
    };
};

export const updateProcessing = (state, action) => {
    return {
        ...state,
        processing: [...state.processing, action.connection.displayName]
    };
};

export const updateProcessingDone = (state, action) => {
    return {
        ...state,
        processing: state.processing.filter((item) => item !== action.connection.displayName)
    };
};

export const setInviteErrorDialogState = (state, action) => {
    return {
        ...state,
        inviteErrorDialog: {
            open: action.open,
            errorType: action.open ? action.errorType : state.inviteErrorDialog.errorType,
            inviteDTO: action.open ? action.inviteDTO : state.inviteErrorDialog.inviteDTO
        }
    };
};

const resetGroupPage = () => {
    return INITIAL_STATE;
};

const handlers = {
    [GROUP_PAGE_SEARCH_USER]: searchUser,
    [GROUP_PAGE_SEARCH_USER_DONE]: searchUserDone,
    [UPDATE_GROUP_SEARCH_USER_CONNECTION_STATUS]: updateSearchUserConnectionStatus,
    [GROUP_PAGE_UNBLOCK_USER]: updateProcessing,
    [GROUP_PAGE_UNBLOCK_USER_DONE]: updateProcessingDone,
    [GROUP_PAGE_CANCEL_INVITE_USER]: updateProcessing,
    [GROUP_PAGE_CANCEL_INVITE_USER_DONE]: updateProcessingDone,
    [GROUP_PAGE_INVITE_USER]: updateProcessing,
    [GROUP_PAGE_INVITE_USER_DONE]: updateProcessingDone,
    [GROUP_PAGE_SET_INVITE_ERROR_DIALOG_STATE]: setInviteErrorDialogState,
    [RESET_GROUP_PAGE]: resetGroupPage
};

export default function groupPageInviteReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) {
        return state;
    }
    return handler(state, action);
}
